import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SendIcon from "@material-ui/icons/Send";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import HeadsetMicOutlinedIcon from "@material-ui/icons/HeadsetMicOutlined";
import HourglassEmptyOutlinedIcon from "@material-ui/icons/HourglassEmptyOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";

// Componentes de dados FICTÍCIOS que aparecem sobre a UI real durante o
// tutorial, ancorados nos containers verdadeiros. Tudo pointer-events:none.

const useStyles = makeStyles((theme) => ({
	"@keyframes demoIn": {
		from: { opacity: 0, transform: "translateY(16px) scale(.97)" },
		to: { opacity: 1, transform: "translateY(0) scale(1)" },
	},
	"@keyframes demoPop": {
		"0%": { opacity: 0, transform: "scale(.85)" },
		"70%": { transform: "scale(1.04)" },
		"100%": { opacity: 1, transform: "scale(1)" },
	},
	"@keyframes demoPulse": {
		"0%": { boxShadow: "0 0 0 0 rgba(16,185,129,.55)" },
		"70%": { boxShadow: "0 0 0 12px rgba(16,185,129,0)" },
		"100%": { boxShadow: "0 0 0 0 rgba(16,185,129,0)" },
	},
	"@keyframes demoTyping": {
		"0%, 60%, 100%": { transform: "translateY(0)", opacity: 0.4 },
		"30%": { transform: "translateY(-4px)", opacity: 1 },
	},
	"@keyframes demoBlink": {
		"0%, 100%": { opacity: 1 },
		"50%": { opacity: 0 },
	},
	"@keyframes demoConfetti": {
		"0%": { transform: "translateY(-10vh) rotate(0deg)", opacity: 1 },
		"100%": { transform: "translateY(105vh) rotate(720deg)", opacity: 0.7 },
	},
	"@keyframes demoQr": {
		from: { opacity: 0, filter: "blur(6px)" },
		to: { opacity: 1, filter: "blur(0)" },
	},
	"@keyframes demoBorder": {
		"0%": { backgroundPosition: "0 0, 0% 50%" },
		"50%": { backgroundPosition: "0 0, 100% 50%" },
		"100%": { backgroundPosition: "0 0, 0% 50%" },
	},
	"@keyframes demoGlow": {
		"0%, 100%": {
			boxShadow:
				"0 20px 60px rgba(2,6,23,.35), 0 0 22px rgba(16,185,129,.28)",
		},
		"50%": {
			boxShadow:
				"0 20px 60px rgba(2,6,23,.35), 0 0 46px rgba(16,185,129,.55)",
		},
	},
	"@keyframes demoBounce": {
		"0%, 100%": { transform: "translateY(0) scale(1)" },
		"50%": { transform: "translateY(-5px) scale(1.15)" },
	},
	// borda gradiente ANIMADA em tudo que o tutorial mostra
	card: {
		"--paper": theme.palette.type === "dark" ? "#0F172A" : "#fff",
		background: `linear-gradient(${
			theme.palette.type === "dark" ? "#0F172A, #0F172A" : "#fff, #fff"
		}) padding-box, linear-gradient(120deg, #10B981, #34D399, #3B82F6, #8B5CF6, #10B981) border-box`,
		backgroundSize: "auto, 300% 300%",
		color: theme.palette.text.primary,
		borderRadius: 16,
		border: "3px solid transparent",
		animation:
			"$demoIn .5s cubic-bezier(.2,.9,.3,1.1) both, $demoBorder 4s ease infinite, $demoGlow 3s ease infinite",
		overflow: "hidden",
	},
	// palco central: modais ficam grandes, centralizados e por cima do blur
	stageCenter: {
		position: "absolute",
		left: "50%",
		top: "44%",
		transform: "translate(-50%, -50%)",
		zIndex: 3,
	},
	// ---- ticket ----
	ticketRow: {
		display: "flex",
		alignItems: "center",
		gap: 12,
		padding: "12px 14px",
	},
	avatar: {
		width: 44,
		height: 44,
		borderRadius: "50%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontWeight: 800,
		fontSize: "1.05rem",
		color: "#fff",
		flexShrink: 0,
	},
	tName: { fontWeight: 700, fontSize: "0.9rem", lineHeight: 1.25 },
	tMsg: {
		fontSize: "0.78rem",
		color: theme.palette.text.secondary,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		maxWidth: 200,
	},
	tRight: {
		marginLeft: "auto",
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-end",
		gap: 6,
	},
	tTime: { fontSize: "0.68rem", color: theme.palette.text.secondary },
	tBadge: {
		background: "#10B981",
		color: "#fff",
		borderRadius: "50%",
		minWidth: 20,
		height: 20,
		fontSize: "0.68rem",
		fontWeight: 800,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: "0 5px",
	},
	acceptBtn: {
		margin: "0 14px 12px",
		background: "#10B981",
		color: "#fff",
		fontWeight: 800,
		fontSize: "0.74rem",
		letterSpacing: "0.08em",
		textAlign: "center",
		borderRadius: 8,
		padding: "8px 0",
		animation: "$demoPulse 1.6s ease-out infinite",
	},
	statusChip: {
		display: "inline-flex",
		alignItems: "center",
		gap: 4,
		fontSize: "0.64rem",
		fontWeight: 800,
		letterSpacing: "0.06em",
		borderRadius: 999,
		padding: "3px 10px",
		color: "#fff",
	},
	// ---- chat ----
	chatPanel: {
		display: "flex",
		flexDirection: "column",
		height: "100%",
		minHeight: 320,
	},
	chatHeader: {
		display: "flex",
		alignItems: "center",
		gap: 10,
		padding: "10px 14px",
		borderBottom: `1px solid rgba(148,163,184,.25)`,
	},
	chatBody: {
		flex: 1,
		padding: 14,
		display: "flex",
		flexDirection: "column",
		gap: 8,
		overflow: "hidden",
		background:
			theme.palette.type === "dark"
				? "rgba(148,163,184,.05)"
				: "rgba(16,185,129,.04)",
	},
	bubbleIn: {
		alignSelf: "flex-start",
		background: theme.palette.type === "dark" ? "#1E293B" : "#fff",
		border: "1px solid rgba(148,163,184,.3)",
		borderRadius: "12px 12px 12px 4px",
		padding: "8px 12px",
		fontSize: "0.82rem",
		maxWidth: "80%",
		animation: "$demoIn .4s ease both",
	},
	bubbleOut: {
		alignSelf: "flex-end",
		background: "#D1FAE5",
		color: "#064E3B",
		borderRadius: "12px 12px 4px 12px",
		padding: "8px 12px",
		fontSize: "0.82rem",
		maxWidth: "80%",
		animation: "$demoIn .4s ease both",
		display: "flex",
		alignItems: "flex-end",
		gap: 6,
	},
	typing: {
		display: "inline-flex",
		gap: 3,
		"& i": {
			width: 6,
			height: 6,
			borderRadius: "50%",
			background: theme.palette.text.secondary,
			animation: "$demoTyping 1.1s infinite",
		},
		"& i:nth-child(2)": { animationDelay: ".15s" },
		"& i:nth-child(3)": { animationDelay: ".3s" },
	},
	chatInput: {
		display: "flex",
		alignItems: "center",
		gap: 10,
		padding: "10px 14px",
		borderTop: `1px solid rgba(148,163,184,.25)`,
	},
	inputBox: {
		flex: 1,
		border: "1px solid rgba(148,163,184,.4)",
		borderRadius: 999,
		padding: "8px 14px",
		fontSize: "0.82rem",
		minHeight: 36,
		display: "flex",
		alignItems: "center",
		color: theme.palette.text.primary,
	},
	caret: {
		display: "inline-block",
		width: 2,
		height: 16,
		background: "#10B981",
		marginLeft: 2,
		animation: "$demoBlink .8s infinite",
	},
	sendBtn: {
		width: 38,
		height: 38,
		borderRadius: "50%",
		background: "#10B981",
		color: "#fff",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0,
	},
	resolvedBar: {
		background: "#10B981",
		color: "#fff",
		fontWeight: 800,
		fontSize: "0.8rem",
		textAlign: "center",
		padding: "9px 0",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: 6,
		animation: "$demoPop .45s ease both",
	},
	resolveBtn: {
		marginLeft: "auto",
		background: "#10B981",
		color: "#fff",
		fontWeight: 800,
		fontSize: "0.72rem",
		borderRadius: 8,
		padding: "6px 14px",
		letterSpacing: "0.05em",
	},
	// ---- QR ----
	qrCard: {
		padding: 28,
		textAlign: "center",
		width: 340,
	},
	qrGrid: {
		width: 190,
		height: 190,
		margin: "0 auto 14px",
		display: "grid",
		gridTemplateColumns: "repeat(10, 1fr)",
		gap: 2,
		padding: 8,
		background: "#fff",
		borderRadius: 12,
		border: "1px solid rgba(148,163,184,.4)",
		animation: "$demoQr .6s ease both",
		"& i": { background: "#0F172A", borderRadius: 1 },
	},
	qrTitle: { fontWeight: 800, fontSize: "0.95rem", marginBottom: 4 },
	qrSub: {
		fontSize: "0.75rem",
		color: theme.palette.text.secondary,
		marginBottom: 10,
	},
	connectedChip: {
		display: "inline-flex",
		alignItems: "center",
		gap: 6,
		background: "#10B981",
		color: "#fff",
		fontWeight: 800,
		fontSize: "0.78rem",
		borderRadius: 999,
		padding: "7px 16px",
		animation: "$demoPop .5s ease both",
	},
	// ---- generic modal ----
	modal: {
		width: 420,
		maxWidth: "calc(100vw - 60px)",
		padding: 26,
	},
	modalTitle: { fontWeight: 800, fontSize: "1.15rem", marginBottom: 16 },
	fieldLabel: {
		fontSize: "0.68rem",
		fontWeight: 700,
		textTransform: "uppercase",
		letterSpacing: "0.06em",
		color: theme.palette.text.secondary,
		marginBottom: 4,
	},
	fieldBox: {
		border: "1px solid rgba(148,163,184,.4)",
		borderRadius: 8,
		padding: "9px 12px",
		fontSize: "0.85rem",
		marginBottom: 12,
		minHeight: 38,
		display: "flex",
		alignItems: "center",
	},
	saveBtn: {
		background: "#10B981",
		color: "#fff",
		fontWeight: 800,
		fontSize: "0.78rem",
		textAlign: "center",
		borderRadius: 8,
		padding: "9px 0",
		marginTop: 4,
	},
	colorRow: { display: "flex", gap: 8, marginBottom: 12 },
	colorDot: {
		width: 26,
		height: 26,
		borderRadius: "50%",
		transition: "transform .25s, box-shadow .25s",
	},
	colorDotPicked: {
		transform: "scale(1.25)",
		boxShadow: "0 0 0 3px #fff, 0 0 0 5px #10B981",
	},
	// ---- rows/chips ----
	plainRow: {
		display: "flex",
		alignItems: "center",
		gap: 12,
		padding: "11px 14px",
	},
	chip: {
		display: "inline-flex",
		alignItems: "center",
		gap: 6,
		borderRadius: 999,
		padding: "6px 14px",
		fontSize: "0.78rem",
		fontWeight: 700,
		color: "#fff",
		marginRight: 8,
		animation: "$demoPop .45s ease both",
	},
	// toast SEMPRE grande e no mesmo lugar (acima da barra de narração)
	toast: {
		position: "fixed",
		bottom: 122,
		left: "50%",
		transform: "translateX(-50%)",
		zIndex: 2545,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: 14,
		padding: "16px 30px",
		fontWeight: 800,
		fontSize: "1.02rem",
		minWidth: 340,
		maxWidth: "72vw",
		whiteSpace: "nowrap",
		"& > span:first-child": {
			display: "inline-block",
			animation: "$demoBounce 1.1s ease infinite",
		},
	},
	toggleTrack: {
		width: 44,
		height: 24,
		borderRadius: 12,
		position: "relative",
		transition: "background .3s",
		flexShrink: 0,
		"& i": {
			position: "absolute",
			top: 3,
			width: 18,
			height: 18,
			borderRadius: "50%",
			background: "#fff",
			transition: "left .3s cubic-bezier(.4,0,.2,1)",
			boxShadow: "0 1px 4px rgba(2,6,23,.3)",
		},
	},
	confettiWrap: {
		position: "fixed",
		inset: 0,
		pointerEvents: "none",
		overflow: "hidden",
		"& i": {
			position: "absolute",
			top: 0,
			width: 9,
			height: 14,
			borderRadius: 2,
			animation: "$demoConfetti 2.8s ease-in forwards",
		},
	},
	slashPopup: {
		border: "1px solid rgba(16,185,129,.5)",
		borderRadius: 10,
		overflow: "hidden",
		marginBottom: 8,
		animation: "$demoPop .35s ease both",
		background: theme.palette.type === "dark" ? "#0F172A" : "#fff",
	},
	slashItem: {
		display: "flex",
		gap: 8,
		alignItems: "center",
		padding: "9px 12px",
		fontSize: "0.8rem",
		background: "rgba(16,185,129,.12)",
	},
	slashKey: {
		fontFamily: "monospace",
		fontWeight: 800,
		color: "#059669",
	},
	// ---- overlay dos cards de estatística (cobre o card real) ----
	statOverlay: {
		display: "flex",
		alignItems: "center",
		gap: 16,
		padding: 20,
		background: theme.palette.background.paper,
		border: `1px solid ${
			(theme.custom && theme.custom.border) || "rgba(148,163,184,.35)"
		}`,
		borderRadius: 4,
		animation: "$demoQr .45s ease both",
	},
	statIcon: {
		width: 48,
		height: 48,
		borderRadius: 12,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0,
	},
	statLabel: {
		fontSize: "0.78rem",
		fontWeight: 600,
		textTransform: "uppercase",
		letterSpacing: "0.05em",
		color: theme.palette.text.secondary,
	},
	statValue: {
		fontWeight: 800,
		fontSize: "1.8rem",
		lineHeight: 1.2,
		letterSpacing: "-0.02em",
		color: theme.palette.text.primary,
	},
	// ---- quadro da equipe (drag and drop ficticio) ----
	board: {
		background: theme.palette.background.paper,
		borderRadius: 4,
		border: `1px solid ${
			(theme.custom && theme.custom.border) || "rgba(148,163,184,.35)"
		}`,
		padding: 24,
		overflow: "hidden",
	},
	boardTitle: {
		fontWeight: 700,
		fontSize: "1.1rem",
		color: theme.palette.text.primary,
	},
	boardSub: {
		fontSize: "0.78rem",
		color: theme.palette.text.secondary,
		marginBottom: 16,
	},
	boardCols: {
		position: "relative",
		display: "flex",
		gap: 14,
		height: "calc(100% - 64px)",
		minHeight: 260,
	},
	boardCol: {
		flex: 1,
		border: `1px solid ${
			(theme.custom && theme.custom.border) || "rgba(148,163,184,.35)"
		}`,
		borderRadius: 12,
		background:
			theme.palette.type === "dark"
				? "rgba(148,163,184,.05)"
				: "rgba(148,163,184,.07)",
		padding: 10,
	},
	boardColHead: {
		display: "flex",
		alignItems: "center",
		gap: 8,
		padding: "4px 6px 10px",
		fontWeight: 700,
		fontSize: "0.85rem",
		color: theme.palette.text.primary,
	},
	boardCount: {
		marginLeft: "auto",
		background: "rgba(148,163,184,.25)",
		borderRadius: 999,
		minWidth: 22,
		height: 22,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontSize: "0.72rem",
		fontWeight: 800,
		padding: "0 6px",
		transition: "all .3s",
	},
	boardHint: {
		border: "1px dashed rgba(148,163,184,.5)",
		borderRadius: 10,
		padding: "18px 8px",
		textAlign: "center",
		fontSize: "0.74rem",
		color: theme.palette.text.secondary,
	},
	boardCard: {
		position: "absolute",
		width: "calc(33.33% - 24px)",
		background: theme.palette.type === "dark" ? "#1E293B" : "#fff",
		border: `1px solid ${
			(theme.custom && theme.custom.border) || "rgba(148,163,184,.4)"
		}`,
		borderRadius: 10,
		padding: "9px 11px",
		display: "flex",
		alignItems: "center",
		gap: 9,
		boxShadow: "0 2px 8px rgba(2,6,23,.12)",
		transition:
			"left 1.15s cubic-bezier(.45,.05,.35,1), top 1.15s cubic-bezier(.45,.05,.35,1), transform .3s, box-shadow .3s",
	},
	boardCardLift: {
		transform: "scale(1.06) rotate(2.5deg)",
		boxShadow: "0 18px 40px rgba(2,6,23,.4)",
		zIndex: 5,
	},
	boardAvatar: {
		width: 32,
		height: 32,
		borderRadius: "50%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontWeight: 800,
		fontSize: "0.8rem",
		color: "#fff",
		flexShrink: 0,
	},
	boardCardName: {
		fontWeight: 700,
		fontSize: "0.8rem",
		color: theme.palette.text.primary,
		lineHeight: 1.2,
	},
	boardCardMsg: {
		fontSize: "0.68rem",
		color: theme.palette.text.secondary,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		maxWidth: 130,
	},
}));

// texto com efeito máquina-de-escrever
const TypeWriter = ({ text = "", speed = 45, showCaret = true }) => {
	const classes = useStyles();
	const [n, setN] = useState(0);
	useEffect(() => {
		setN(0);
		if (!text) return undefined;
		const t = setInterval(() => {
			setN((v) => {
				if (v >= text.length) {
					clearInterval(t);
					return v;
				}
				return v + 1;
			});
		}, speed);
		return () => clearInterval(t);
	}, [text, speed]);
	return (
		<span>
			{text.slice(0, n)}
			{showCaret && n < text.length && <span className={classes.caret} />}
		</span>
	);
};

// numero que "conta" ate o valor alvo
const CountUp = ({ to = 0, dur = 1100 }) => {
	const [v, setV] = useState(0);
	useEffect(() => {
		let raf;
		let t0 = null;
		const tick = (t) => {
			if (t0 === null) t0 = t;
			const k = Math.min(1, (t - t0) / dur);
			setV(Math.round(to * (1 - Math.pow(1 - k, 3))));
			if (k < 1) raf = requestAnimationFrame(tick);
		};
		raf = requestAnimationFrame(tick);
		return () => cancelAnimationFrame(raf);
	}, [to, dur]);
	return <>{v}</>;
};

const QR_SEED = [1, 0, 1, 1, 0, 0, 1, 0, 1, 1];
const QrPattern = () => {
	const classes = useStyles();
	const cells = [];
	for (let i = 0; i < 100; i += 1) {
		const on =
			QR_SEED[i % 10] === 1 ? (i * 13) % 4 !== 0 : (i * 7 + 3) % 5 === 0;
		cells.push(on ? <i key={i} /> : <span key={i} />);
	}
	return <div className={classes.qrGrid}>{cells}</div>;
};

const Demo = ({ kind, props = {} }) => {
	const classes = useStyles();

	switch (kind) {
		case "ticketRow": {
			const {
				name = "Maria Souza",
				initial = "M",
				color = "#8B5CF6",
				msg = "Oi! Queria saber o valor do plano…",
				time = "agora",
				badge = 2,
				accept = false,
				status = null,
				style = {},
			} = props;
			return (
				<div className={classes.card} style={style} data-demo="ticket">
					<div className={classes.ticketRow}>
						<div className={classes.avatar} style={{ background: color }}>
							{initial}
						</div>
						<div style={{ minWidth: 0 }}>
							<div className={classes.tName}>{name}</div>
							<div className={classes.tMsg}>{msg}</div>
						</div>
						<div className={classes.tRight}>
							<span className={classes.tTime}>{time}</span>
							{badge > 0 && <span className={classes.tBadge}>{badge}</span>}
							{status && (
								<span
									className={classes.statusChip}
									style={{
										background: status === "ATENDENDO" ? "#10B981" : "#F59E0B",
									}}
								>
									{status}
								</span>
							)}
						</div>
					</div>
					{accept && (
						<div className={classes.acceptBtn} data-demo="accept">
							ACEITAR
						</div>
					)}
				</div>
			);
		}

		case "chatPanel": {
			const {
				contact = "Maria Souza",
				initial = "M",
				color = "#8B5CF6",
				items = [],
				inputText = "",
				inputDone = false,
				resolved = false,
				style = {},
			} = props;
			return (
				<div className={`${classes.card} ${classes.chatPanel}`} style={style} data-demo="chat">
					<div className={classes.chatHeader}>
						<div
							className={classes.avatar}
							style={{ background: color, width: 34, height: 34, fontSize: "0.85rem" }}
						>
							{initial}
						</div>
						<div>
							<div className={classes.tName}>{contact}</div>
							<div className={classes.tMsg} style={{ color: "#10B981" }}>
								online
							</div>
						</div>
						<div className={classes.resolveBtn} data-demo="resolve">RESOLVER</div>
					</div>
					<div className={classes.chatBody}>
						{items.map((it, i) => {
							if (it.from === "typing")
								return (
									<div key={i} className={classes.bubbleIn}>
										<span className={classes.typing}>
											<i />
											<i />
											<i />
										</span>
									</div>
								);
							return (
								<div
									key={i}
									className={
										it.from === "in" ? classes.bubbleIn : classes.bubbleOut
									}
								>
									{it.text}
									{it.from === "out" && (
										<DoneAllIcon style={{ fontSize: 14, color: "#059669" }} />
									)}
								</div>
							);
						})}
					</div>
					{resolved ? (
						<div className={classes.resolvedBar}>
							<CheckCircleIcon style={{ fontSize: 18 }} /> Atendimento resolvido!
						</div>
					) : (
						<div className={classes.chatInput}>
							<div className={classes.inputBox}>
								{inputDone ? (
									inputText
								) : (
									<TypeWriter text={inputText} speed={40} />
								)}
							</div>
							<div className={classes.sendBtn} data-demo="send">
								<SendIcon style={{ fontSize: 18 }} />
							</div>
						</div>
					)}
				</div>
			);
		}

		case "qrCard": {
			const { status = "qr", style = {} } = props;
			return (
				<div className={classes.stageCenter}><div className={`${classes.card} ${classes.qrCard}`} data-demo="qr">
					<div className={classes.qrTitle}>Adicionar WhatsApp</div>
					<div className={classes.qrSub}>
						Escaneie com o celular: WhatsApp → Aparelhos conectados
					</div>
					{status === "connected" ? (
						<div style={{ padding: "28px 0" }}>
							<span className={classes.connectedChip}>
								<WhatsAppIcon style={{ fontSize: 18 }} /> CONECTADO
							</span>
						</div>
					) : (
						<QrPattern />
					)}
					{status === "connecting" && (
						<div className={classes.qrSub}>Conectando…</div>
					)}
				</div></div>
			);
		}

		case "contactRow": {
			const {
				name = "João Pereira",
				number = "+55 11 99999-1234",
				initial = "J",
				color = "#3B82F6",
				highlight = false,
				style = {},
			} = props;
			return (
				<div
					className={classes.card}
					style={{
						...(highlight
							? { boxShadow: "0 0 0 4px rgba(16,185,129,.35)" }
							: {}),
						...style,
					}}
					data-demo={`contact-${initial}`}
				>
					<div className={classes.plainRow}>
						<div
							className={classes.avatar}
							style={{ background: color, width: 38, height: 38, fontSize: "0.9rem" }}
						>
							{initial}
						</div>
						<div>
							<div className={classes.tName}>{name}</div>
							<div className={classes.tMsg}>{number}</div>
						</div>
						<WhatsAppIcon style={{ marginLeft: "auto", color: "#10B981" }} />
					</div>
				</div>
			);
		}

		case "formModal": {
			const { title = "", fields = [], saving = false, style = {} } = props;
			return (
				<div className={classes.stageCenter}><div className={`${classes.card} ${classes.modal}`} data-demo="modal">
					<div className={classes.modalTitle}>{title}</div>
					{fields.map((f, i) => (
						<div key={i}>
							<div className={classes.fieldLabel}>{f.label}</div>
							<div className={classes.fieldBox}>
								{f.done ? f.value : <TypeWriter text={f.value} speed={55} />}
							</div>
						</div>
					))}
					<div
						className={classes.saveBtn}
						data-demo="save"
						style={saving ? { opacity: 0.75 } : {}}
					>
						{saving ? "SALVANDO…" : "SALVAR"}
					</div>
				</div></div>
			);
		}

		case "queueModal": {
			const {
				name = "Vendas",
				nameDone = false,
				picked = -1,
				saving = false,
				style = {},
			} = props;
			const palette = ["#10B981", "#3B82F6", "#8B5CF6", "#F59E0B", "#EF4444"];
			return (
				<div className={classes.stageCenter}><div className={`${classes.card} ${classes.modal}`} data-demo="modal">
					<div className={classes.modalTitle}>Nova fila</div>
					<div className={classes.fieldLabel}>Nome</div>
					<div className={classes.fieldBox}>
						{nameDone ? name : <TypeWriter text={name} speed={60} />}
					</div>
					<div className={classes.fieldLabel}>Cor</div>
					<div className={classes.colorRow}>
						{palette.map((c, i) => (
							<div
								key={c}
								data-demo={`color-${i}`}
								className={`${classes.colorDot} ${
									picked === i ? classes.colorDotPicked : ""
								}`}
								style={{ background: c }}
							/>
						))}
					</div>
					<div className={classes.saveBtn} data-demo="save">
						{saving ? "SALVANDO…" : "SALVAR"}
					</div>
				</div></div>
			);
		}

		case "chipRow": {
			const { items = [], style = {} } = props;
			return (
				<div style={style}>
					{items.map((q, i) => (
						<span
							key={q.name}
							className={classes.chip}
							style={{ background: q.color, animationDelay: `${i * 0.18}s` }}
						>
							{q.name}
						</span>
					))}
				</div>
			);
		}

		case "userRow": {
			const {
				name = "Ana Lima",
				email = "ana@flytec.com",
				initial = "A",
				color = "#F59E0B",
				profile = "Atendente",
				queue = "Vendas",
				style = {},
			} = props;
			return (
				<div className={classes.card} style={style}>
					<div className={classes.plainRow}>
						<div
							className={classes.avatar}
							style={{ background: color, width: 38, height: 38, fontSize: "0.9rem" }}
						>
							{initial}
						</div>
						<div>
							<div className={classes.tName}>{name}</div>
							<div className={classes.tMsg}>
								{email} · {profile} · fila {queue}
							</div>
						</div>
						<CheckCircleIcon style={{ marginLeft: "auto", color: "#10B981" }} />
					</div>
				</div>
			);
		}

		case "quickAnswerRow": {
			const {
				shortcut = "/saudacao",
				message = "Olá! Bem-vindo à Flytec 👋 Como posso ajudar?",
				style = {},
			} = props;
			return (
				<div className={classes.card} style={style}>
					<div className={classes.plainRow}>
						<span
							className={classes.chip}
							style={{ background: "#0F172A", fontFamily: "monospace" }}
						>
							{shortcut}
						</span>
						<div className={classes.tMsg} style={{ maxWidth: 260 }}>
							{message}
						</div>
					</div>
				</div>
			);
		}

		case "chatSlash": {
			const { typed = "/", popup = false, filled = "", style = {} } = props;
			return (
				<div style={style}>
					{popup && (
						<div className={classes.slashPopup}>
							<div className={classes.slashItem} data-demo="slash-item">
								<span className={classes.slashKey}>/saudacao</span>
								<span style={{ opacity: 0.75 }}>
									Olá! Bem-vindo à Flytec 👋…
								</span>
							</div>
						</div>
					)}
					<div className={`${classes.card}`} style={{ animation: "none" }}>
						<div className={classes.chatInput} style={{ borderTop: "none" }}>
							<div className={classes.inputBox} data-demo="slash-input">
								{filled || (
									<span>
										{typed}
										<span className={classes.caret} />
									</span>
								)}
							</div>
							<div className={classes.sendBtn} data-demo="send">
								<SendIcon style={{ fontSize: 18 }} />
							</div>
						</div>
					</div>
				</div>
			);
		}

		case "settingRow": {
			const { label = "Criação automática de tickets", on = false, style = {} } =
				props;
			return (
				<div className={classes.card} style={style}>
					<div className={classes.plainRow}>
						<div style={{ fontSize: "0.85rem", fontWeight: 700 }}>{label}</div>
						<div
							className={classes.toggleTrack}
							data-demo="toggle"
							style={{
								marginLeft: "auto",
								background: on ? "#10B981" : "rgba(148,163,184,.5)",
							}}
						>
							<i style={{ left: on ? 23 : 3 }} />
						</div>
					</div>
				</div>
			);
		}

		case "toast": {
			const { icon = "🎉", text = "", style = {} } = props;
			return (
				<div className={`${classes.card} ${classes.toast}`} style={style}>
					<span style={{ fontSize: "1.2rem" }}>{icon}</span> {text}
				</div>
			);
		}

		case "statOverlay": {
			const { label = "", value = 0, colorKey = "open", style = {} } = props;
			const palette = {
				open: { bg: "rgba(5,150,105,.12)", fg: "#059669" },
				pending: { bg: "rgba(245,158,11,.12)", fg: "#F59E0B" },
				closed: { bg: "rgba(14,165,233,.12)", fg: "#0EA5E9" },
			}[colorKey];
			const icons = {
				open: <HeadsetMicOutlinedIcon />,
				pending: <HourglassEmptyOutlinedIcon />,
				closed: <CheckCircleOutlineOutlinedIcon />,
			};
			return (
				<div className={classes.statOverlay} style={style}>
					<div
						className={classes.statIcon}
						style={{ backgroundColor: palette.bg, color: palette.fg }}
					>
						{icons[colorKey]}
					</div>
					<div>
						<div className={classes.statLabel}>{label}</div>
						<div className={classes.statValue}>
							<CountUp to={value} />
						</div>
					</div>
				</div>
			);
		}

		case "teamBoard": {
			const { phase = "intro", style = {} } = props;
			// colunas: 0 = Aguardando, 1 = Administrador (voce), 2 = Ana Lima
			const colLeft = ["12px", "calc(33.33% + 8px)", "calc(66.66% + 4px)"];
			const mariaAt =
				phase === "intro" ? 0 : 1; // Maria vai para a coluna do admin
			const carlosAt =
				phase === "dragCarlos" || phase === "done" ? 2 : 0;
			const carlosTop =
				phase === "afterMaria" || phase === "dragCarlos" || phase === "done"
					? 46
					: 112;
			const counts = {
				intro: [2, 0, 0],
				dragMaria: [1, 0, 0],
				afterMaria: [1, 1, 0],
				dragCarlos: [0, 1, 0],
				done: [0, 1, 1],
			}[phase] || [2, 0, 0];
			const col = (icon, title, count, hint) => (
				<div className={classes.boardCol}>
					<div className={classes.boardColHead}>
						{icon}
						<span>{title}</span>
						<span
							className={classes.boardCount}
							style={
								count > 0
									? { background: "#10B981", color: "#fff" }
									: {}
							}
						>
							{count}
						</span>
					</div>
					{hint && <div className={classes.boardHint}>Solte um atendimento aqui</div>}
				</div>
			);
			return (
				<div className={classes.board} style={style}>
					<div className={classes.boardTitle}>Atendimentos da equipe</div>
					<div className={classes.boardSub}>
						Arraste um atendimento para transferi-lo entre atendentes.
					</div>
					<div className={classes.boardCols}>
						{col(
							<HourglassEmptyOutlinedIcon
								style={{ fontSize: 18, color: "#F59E0B" }}
							/>,
							"Aguardando",
							counts[0],
							counts[0] === 0
						)}
						{col(
							<div
								className={classes.boardAvatar}
								style={{ background: "#059669", width: 24, height: 24, fontSize: "0.65rem" }}
							>
								A
							</div>,
							"Administrador (você)",
							counts[1],
							counts[1] === 0
						)}
						{col(
							<div
								className={classes.boardAvatar}
								style={{ background: "#F59E0B", width: 24, height: 24, fontSize: "0.65rem" }}
							>
								AL
							</div>,
							"Ana Lima",
							counts[2],
							counts[2] === 0
						)}

						{/* cards que se movem entre as colunas */}
						<div
							className={`${classes.boardCard} ${
								phase === "dragMaria" ? classes.boardCardLift : ""
							}`}
							data-demo="card-maria"
							style={{ left: colLeft[mariaAt], top: 46 }}
						>
							<div
								className={classes.boardAvatar}
								style={{ background: "#8B5CF6" }}
							>
								M
							</div>
							<div>
								<div className={classes.boardCardName}>Maria Souza</div>
								<div className={classes.boardCardMsg}>
									Oi! Queria saber o valor…
								</div>
							</div>
						</div>
						<div
							className={`${classes.boardCard} ${
								phase === "dragCarlos" ? classes.boardCardLift : ""
							}`}
							data-demo="card-carlos"
							style={{ left: colLeft[carlosAt], top: carlosTop }}
						>
							<div
								className={classes.boardAvatar}
								style={{ background: "#0EA5E9" }}
							>
								C
							</div>
							<div>
								<div className={classes.boardCardName}>Carlos Mendes</div>
								<div className={classes.boardCardMsg}>
									Preciso de suporte no app
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		}

		case "confetti": {
			const colors = ["#10B981", "#34D399", "#3B82F6", "#F59E0B", "#8B5CF6", "#EF4444"];
			const pieces = [];
			for (let i = 0; i < 34; i += 1) {
				pieces.push(
					<i
						key={i}
						style={{
							left: `${(i * 137) % 100}%`,
							background: colors[i % colors.length],
							animationDelay: `${(i % 9) * 0.14}s`,
							animationDuration: `${2.2 + ((i * 53) % 10) / 8}s`,
						}}
					/>
				);
			}
			return <div className={classes.confettiWrap}>{pieces}</div>;
		}

		default:
			return null;
	}
};

export default Demo;
